import React from "react";

const PdfViewer = ({ url, onClose }) => {
  if (!url) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <iframe src={url} title="PDF Viewer" style={styles.iframe} />
        <div style={styles.controls}>
          <a href={url} download target="_blank" rel="noopener noreferrer" style={styles.download}>⬇ Download</a>
          <button onClick={onClose} style={styles.close}>✖ Close</button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0,0,0,0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000
  },
  modal: {
    backgroundColor: "#fff",
    width: "80%",
    height: "80%",
    borderRadius: "8px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column"
  },
  iframe: {
    flex: 1,
    width: "100%",
    border: "none"
  },
  controls: {
    display: "flex",
    justifyContent: "space-between",
    padding: "1rem",
    borderTop: "1px solid #ccc",
    background: "#f9f9f9"
  },
  close: {
    padding: "10px 20px",
    background: "#217867",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer"
  },
  download: {
    textDecoration: "none",
    color: "#217867",
    fontWeight: "bold"
  }
};

export default PdfViewer;
